<script setup lang="ts">
defineProps<{
  open?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <div v-if="open" class="ui-modal-dub-error">
    <div class="overlay" @click="emit('close')" />
    <div class="modal">
      <div class="modal-content pr-10">
        <slot />
      </div>
      <button class="close-btn" type="button" @click="emit('close')" />
      <div class="modal-separator block w-full mb-4" />
      <div class="modal-actions text-right flex items-center justify-end gap-2">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 99;
  padding: 0 18px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #00000034;
  transition: all 0.3s ease-in-out;
}

.modal {
  position: fixed;
  z-index: 100;
  min-width: 320px;
  max-width: 505px;
  padding: 24px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border: 1px solid #e5ecf1;
  box-shadow:
    0px 4px 8px -2px rgba(4, 8, 13, 0.12),
    0px 16px 24px -4px rgba(4, 8, 13, 0.12);
  border-radius: 16px;

  :deep(.modal-content__text) {
    font-size: 15px;

    p {
      margin-bottom: 12px;
    }
  }
}

@media screen and (max-width: 580px) {
  .modal {
    padding: 16px;
  }
}

.close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  background-color: #3b6d9514;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;

  &::before,
  &::after {
    content: '';
    position: absolute;
    display: block;
    width: 16px;
    height: 2px;
    border-radius: 4px;
    background-color: #091620cc;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
}

.modal-separator {
  border-top: 1px solid #e5ecf1;
}
</style>
